module.exports = __webpack_public_path__ + "img/brasao-sem-texto.9053ba9c.png";